"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChartToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.getChartToken = function (targetId, dataGroupType, chartGroupNewType, chartRangeType, from, to, languageCode, token) {
    var requestBody = {
        targetId: targetId,
        dataGroupType: dataGroupType,
        chartGroupNewType: chartGroupNewType,
        chartRangeType: chartRangeType,
        from: from,
        to: to,
    };
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/transaction/GetChartNewData",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: requestBody,
    });
};
